import React, { Fragment } from 'react'
// import { Spinner } from 'react-bootstrap';
import ImageURL from '../assets/loading.gif'
import FadeIn from 'react-fade-in';

const Loading = ({ size = 'medium' }) => {
  return (
    <Fragment>
      <div style={{ marginTop: 125 }} />
      <FadeIn>
        <center>
          {/* <Spinner animation="border" role="status">
            <span className="sr-only">Loading...</span>
          </Spinner> */}
          <img src={ImageURL} style={{ height: getSize(size) }} alt="cargando" />
        </center>
      </FadeIn>
    </Fragment>
  );
};

export default Loading


const getSize = size => {

  const baseSize = 16;

  switch (size) {
    case 'medium':
      return baseSize * 3;
    case 'small':
      return baseSize * 2;
    case 'big':
      return baseSize * 4;
    case 'large':
      return baseSize * 5;
    case 'tiny':
      return baseSize;
    default:
      return 32
  }
}